<div class="app-toast__container">
  @if (showHeader() && title()) {
    <div class="app-toast__header-row">
      <div class="app-toast__title-wrapper">
        @if (showLeftIcon()) {
          <div class="app-toast__icon-wrapper">
            <i
              class="icons app-toast__icon"
              [class]="getLeftIconClass()"
              [class.app-toast__icon--spin]="isProcess() && tone() === 'neutral'"></i>
          </div>
        }
        <div class="app-toast__title">{{ title() }}</div>
      </div>
      @if (!isProcess()) {
        <button class="app-toast__close-btn" (click)="onClose()" aria-label="Close">
          <i class="icons icon-times"></i>
        </button>
      }
    </div>
  }

  @if (showMessage()) {
    <div class="app-toast__message">{{ message() }}</div>
  }
</div>
